export default __webpack_public_path__ + "static/media/Made.com - Logo.fbb8610b.png";